import { NavLink, Navigate, Outlet, useParams } from 'react-router-dom';
import { useContactSession } from './ContactSessionProvider';
import { usePortalOverview } from './usePortalOverview';
import { initials } from './portalUtils';
import './portal.css';

const TABS = [
  { to: 'home', label: 'Home' },
  { to: 'sessions', label: 'Sessions' },
  { to: 'nutrition', label: 'Nutrition' },
  { to: 'workout', label: 'Workout' },
  { to: 'profile', label: 'Profile' },
];

/** Shell for the authed portal: trainer header + tab nav + routed page. Guards auth. */
export function PortalLayout() {
  const { workspaceId = '' } = useParams<{ workspaceId: string }>();
  const { status } = useContactSession();
  const { data } = usePortalOverview();
  if (status !== 'authed') {
    return <Navigate to={`/portal/${workspaceId}`} replace />;
  }
  const trainer = data?.trainer;
  const clientName = data?.client?.name || 'You';
  return (
    <div className="portal-shell">
      <div className="portal-topbar">
        <div className="portal-topbar-trainer">
          <div className="portal-topbar-avatar portal-trainer-initials">{initials(clientName)}</div>
          <div>
            <div className="portal-topbar-name">{clientName}</div>
            {trainer?.name && <div className="portal-trainer-sub">Trainer: {trainer.name}</div>}
          </div>
        </div>
      </div>

      <nav className="portal-nav">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={`/portal/${workspaceId}/${t.to}`}
            className={({ isActive }) => `portal-nav-tab${isActive ? ' active' : ''}`}
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
